import { ChangeEventHandler } from 'react';
import styles from './PasswordInput.module.css';
import { StyleProps } from './types';

type Props = StyleProps & {
	isCentered?: boolean;
	onChange?: ChangeEventHandler<HTMLInputElement>;
};

const PasswordInput = ({ isCentered, onChange, className, style }: Props) =>
{
	const handleChange = (event: React.ChangeEvent<HTMLInputElement>) =>
	{
		onChange?.(event);
	};

	return (
		<input className={`${styles.input}${className ? ` ${className}` : ''}`} onChange={handleChange} type="password" placeholder='Enter the password here' style={{ ...(isCentered ? { textAlign: "center" } : {}), ...style }} />
	);
};

export default PasswordInput;